import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Card, CardContent, Stack, Button, CircularProgress, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { usersActions } from "../../../../modules/users/users.actions";

function DashboardFormModal({ open, onClose, tournee, onSave, loading, dispatch, clients }) {
    const [selectedForm, setSelectedForm] = useState(tournee?.formulaire?.['@id'] || '');
    const [availableForms, setAvailableForms] = useState([]);

    useEffect(() => {
        // If clients are not loaded, fetch them
        if (!clients && !loading) {
            dispatch(usersActions.fetchClients());
        }
    }, [clients, loading, dispatch]);

    useEffect(() => {
        if (open && tournee && clients) {
            // Find the client object that matches the tournee's client
            const clientId = tournee.clientId;
            const client = clients.find(c => c.id.toString() === clientId.toString());

            // If client is found and has forms, set them as available forms
            if (client && client.forms) {
                setAvailableForms(client.forms);
            }

            // Set the selected form using formId if available, otherwise fall back to formulaire['@id']
            if (tournee.formId) {
                // Find the form with matching ID and use its @id
                const form = client?.forms.find(f => f.id.toString() === tournee.formId.toString());
                if (form) {
                    setSelectedForm(form['@id']);
                } else {
                    setSelectedForm(tournee?.formulaire?.['@id'] || '');
                }
            } else {
                setSelectedForm(tournee?.formulaire?.['@id'] || '');
            }
        }
    }, [open, tournee, clients]);

    const handleFormChange = (event) => {
        setSelectedForm(event.target.value);
    };

    const handleSave = () => {
        onSave(tournee?.id, selectedForm);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle><strong>{tournee?.libelle}</strong></DialogTitle>

            <DialogContent>
                <Stack direction="row" spacing={2} justifyContent="space-evenly">
                    <Card sx={{ width: '100%' }}>
                        <CardContent>
                            <FormControl fullWidth>
                                <InputLabel id="form-select-label">Formulaire</InputLabel>
                                <Select
                                    labelId="form-select-label"
                                    value={selectedForm}
                                    label="Formulaire"
                                    onChange={handleFormChange}
                                >
                                    {availableForms.map((form) => (
                                        <MenuItem key={form.id} value={form['@id']}>
                                            {form.libelle}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </CardContent>
                    </Card>
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleSave} variant="contained" color="secondary" disabled={!selectedForm || loading}>
                    {!loading ? "Sauvegarder les modifications" : <CircularProgress size={20} />}
                </Button>
                <Button onClick={onClose} variant="contained" color="primary">
                    Annuler
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const mapStateToProps = (state) => {
    return {
        clients: state.users.clients,
        loading: state.users.loading
    };
};

export default connect(mapStateToProps)(DashboardFormModal);
